"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLongStatus = createLongStatus;
const events_1 = require("../../../events");
const committeeOpinion_1 = require("../../../forms/ktx/committeeOpinion");
const messages_1 = require("../messages");
const queries_1 = require("../queries");
function createLongStatus({ formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.patientStatus);
    const status = event?.value ?? committeeOpinion_1.Status.NEW;
    return formatMessageMap(messages_1.longStatusMessages, status);
}
